import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";
import * as URL from "../../helpers/url_helper";

const api = new APIClient();

export const fetchAffiliateDashboard = createAsyncThunk(
  "affiliate/dashboard",
  async () => api.get(URL.AFFILIATE_DASHBOARD)
);

const slice = createSlice({
  name: "affiliate",
  initialState: {
    loading: false,
    error: null,
    affiliateCode: null,
    affiliateLink: "",
    commissionPercent: 30,
    maxCycles: 12,
    totalPendingPaise: 0,
    totalPaidPaise: 0,
    totalEarningsPaise: 0,
    commissionCount: 0,
    commissions: [],
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchAffiliateDashboard.pending,   (s) => { s.loading = true; s.error = null; })
     .addCase(fetchAffiliateDashboard.fulfilled, (s, a) => {
       s.loading = false;
       Object.assign(s, a.payload);
     })
     .addCase(fetchAffiliateDashboard.rejected,  (s, a) => {
       s.loading = false; s.error = a.error.message;
     });
  },
});

export default slice.reducer;
